const modes = {
    scpi: {
        label: 'SCPI',
    },
    av: {
        label: 'Assurance-vie',
    },
    per: {
        label: 'PER',
    },
    managementAct: {
        label: 'Acte de Gestion',
    },
    businessPartner: {
        label: 'Partenaire',
    },
};

export default modes;
